import api from './api';

export const authService = {
  login: async (email, password) => {
    const response = await api.post('/admin/login', { email, password });
    if (response.data.access_token) {
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  getProfile: async () => {
    const response = await api.get('/admin/me');
    return response.data;
  },

  updateProfile: async (data) => {
    const response = await api.put('/admin/profile', data);
    return response.data;
  },

  changePassword: async (data) => {
    const response = await api.post('/admin/change-password', data);
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },

  getUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },
};
